import { useContext } from 'react';

import { ModalPopupContext } from './ModalPopupContext';

export const useModal = () => {
  const context = useContext(ModalPopupContext);

  if (!context) {
    throw new Error('useModal must be used within ModalPopupProvider');
  }

  return context;
};
